// 구매내역 삭제 확인창 문구 — 무엇을 지우는지 화면에 이미 있는 값(화주 회사·주문번호·상품명·수량)으로 보여준다
export function purchaseDeleteMessage(items, all) {
  const list = items || []
  const rows = list.slice(0, 5).map(p =>
    '· ' + [p.companyid, p.주문번호, p.상품명, p.주문수량 != null && p.주문수량 !== '' ? p.주문수량 + '개' : ''].filter(Boolean).join(' / '))
  if (list.length > 5) rows.push('· 외 ' + (list.length - 5) + '건 (还有 ' + (list.length - 5) + ' 条)')
  return (all ? '전체 ' + list.length + '건을 삭제합니다. (将删除全部 ' + list.length + ' 条)' : '총 ' + list.length + '건을 삭제합니다. (将删除 ' + list.length + ' 条)') + '\n' + rows.join('\n') + '\n\n' +
    '삭제하면 구매내역이 목록에서 사라지고, 연결된 구매요청의 진행현황이 「구매확인」으로 돌아갑니다. 삭제 후 30일 동안 관리자가 복구할 수 있습니다.\n' +
    '删除后采购记录会从列表消失，关联采购申请的进度退回「采购确认」。删除后 30 天内管理员可以恢复。\n' +
    '※ 删除不是取消 (삭제는 취소가 아닙니다)'
}
